export const triggerHotJarEvent = (eventName) => {
  if (window.hj) {
    window.hj('event', eventName);
  } else {
    // eslint-disable-next-line no-console
    console.warn('Hot jar is not loaded yet');
  }
};
